var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmployeesForm',{attrs:{"editMode":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }